module.exports = __webpack_public_path__ + "img/iconKongZhiDiBangDaoZha.5c2736e7.svg";